<template>
    <modal @close="modeResetAction">
        <template slot="header_title">
            Sauvegarde
        </template>
        <template slot="main">
            <div class="main_story_delete_component">
                <strong>Voulez-vous vraiment quitter sans sauvegarder ?</strong>
                <br>Les données non sauvegarder seront perdus.
                <br>Impossible d’annuler cette opération.
            </div>
        </template>
        <template slot="footer">
            <v-layout row wrap>
                <v-flex xs6>
                    <v-btn class="custom_btn_position custom_btn_color_red" @click="localNotSaveAction">
                        <i class="fas fa-times fa-btn" />
                        <span v-if="!isMobile">Quitter sans sauvegarder</span>
                    </v-btn>
                </v-flex>
                <v-flex xs6>
                    <v-btn class="custom_btn_position custom_btn_color_blue" @click="localSaveAction">
                        <i class="fas fa-check fa-btn" />
                        <span v-if="!isMobile">Sauvegarder</span>
                    </v-btn>
                </v-flex>
            </v-layout>
        </template>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import modal from '../../global/modal';

    export default {
        name: 'StoryUpdateComponent',
        components: { modal },
        computed: {
            ...mapGetters('app', ['isMobile'])
        },
        methods: {
            ...mapActions('actions', ['updateActionData', 'modeResetAction']),
            ...mapActions('app', ['showOverlay', 'hideOverlay']),
            localNotSaveAction: function () {
                this.modeResetAction();
                this.$router.push({
                    name: 'augmentations',
                    params: { experienceToken: this.$route.params.experienceToken }
                });
            },
            localSaveAction: function () {
                let currentData = 'current' + this.$store.state.actions.action.action_type.charAt(0).toUpperCase() +
                    this.$store.state.actions.action.action_type.slice(1);
                let data = this.$store.state.actions[this.$store.state.actions.action.action_type][currentData];
                this.showOverlay();
                this.updateActionData(data).then(() => {
                    this.hideOverlay();
                    this.$router.push({
                        name: 'augmentations',
                        params: { experienceToken: this.$route.params.experienceToken }
                    });
                    this.$toasted.success('Changement correctement pris en compte.');
                    this.modeResetAction();
                }).catch((err) => {
                    this.$toasted.error(err);
                    this.hideOverlay();
                    this.modeResetAction();
                });
            }
        }
    };
</script>

<style scoped>
    .main_story_delete_component {
        padding: 20px;
        text-align: center;
    }
</style>
